import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { HolidayTypeStateClass } from './interfaces/holidayTypeStateClass';
import { sortData } from "../../../common/timeLiveFunction";

const initialState: HolidayTypeStateClass = {
    isLoading: true,
    status: 'idle',
    holidayTypeList: [],
    selectedRecord: {},
    isReload : false,
    sortOrder: 'asc',
    sortColumn: 'AccountHolidayType',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        holidayType: HolidayTypeStateClass;
    },
}
export const getHolidayTypesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'holidayType/getHolidayTypes',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/HolidayTypes', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const getHolidayTypesByIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayType/getHolidayTypesById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/HolidayTypes/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    
    export const addHolidayTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayType/addHolidayType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/HolidayTypes/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const updateHolidayTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayType/updateHolidayType',
        async (arg, thunkApi) => {
            const { AccountHolidayTypeId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/HolidayTypes/' + AccountHolidayTypeId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteHolidayTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'holidayType/deleteHolidayType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/HolidayTypes/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
    export const deleteAllSelectedRecordHolidayTypeAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "paymentMethod/DeleteAllSelectedRecordHolidayType",
        async(arg,thunkApi) =>{
            console.log('farhan',arg);
            const response = await fetchAPI('api/v2/HolidayTypes/DeleteAllSelectedRecordHolidayType/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        
        }
    )
  
export const holidayTypeSlice = createSlice({
    name: 'holidayType',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.holidayTypeList.findIndex((item) => item.AccountHolidayTypeId == action.payload);
            const newArray = [...state.holidayTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.holidayTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.holidayTypeList.findIndex((item) => item.AccountHolidayTypeId == action.payload);
            const newArray = [...state.holidayTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.holidayTypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.holidayTypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.holidayTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.holidayTypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.holidayTypeList = newArray;
            //state.isAllUnChecked = true;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.holidayTypeList;
            state.holidayTypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },


    extraReducers: (builder) => {
        builder
            .addCase(getHolidayTypesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; 
            })
            .addCase(getHolidayTypesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.holidayTypeList = payload.Data;
                // state.holidayTypeList.forEach((item: any) => {
                //     item.isSelected = 0;
                // });
                if (Object.keys(payload.Data).length === 0) {
                    state.holidayTypeList = [];
                } else {
                    state.holidayTypeList = payload.Data;
                    state.holidayTypeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false; 
                state.selectedRecord = {};
            })
            .addCase(getHolidayTypesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; 
            })
    
            .addCase(getHolidayTypesByIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; 
            })
            .addCase(getHolidayTypesByIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                console.log('getHolidayTypesByIdAsync', payload.Data);
                state.selectedRecord = payload.Data[0];
                state.isLoading = false; 
            })
            .addCase(getHolidayTypesByIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; 
            })
    
            .addCase(addHolidayTypeAsync.pending, (state) => {                
                state.isLoading = true; 
            })
            .addCase(addHolidayTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
               
            })
            .addCase(addHolidayTypeAsync.rejected, (state) => {
                state.status = 'failed';
                // state.isLoading = false; // Set isLoading to false when request is rejected
            })
    
            .addCase(updateHolidayTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; // Set isLoading to true when request is pending
            })
            .addCase(updateHolidayTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false; // Set isLoading to false when request is fulfilled
            })
            .addCase(updateHolidayTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; // Set isLoading to false when request is rejected
            })
    
            .addCase(deleteHolidayTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; // Set isLoading to true when request is pending
            })
            .addCase(deleteHolidayTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false; // Set isLoading to false when request is fulfilled
            })
            .addCase(deleteHolidayTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; // Set isLoading to false when request is rejected
            })
    
            .addCase(deleteAllSelectedRecordHolidayTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; // Set isLoading to true when request is pending
            })
            .addCase(deleteAllSelectedRecordHolidayTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false; // Set isLoading to false when request is fulfilled
            })
            .addCase(deleteAllSelectedRecordHolidayTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; // Set isLoading to false when request is rejected
            });
    }

})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState,updateSorting, updatePagination
} = holidayTypeSlice.actions
  export const holidayTypeStateClass = (state: RootState) => state.holidayType
 export default holidayTypeSlice.reducer